function isPlainObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
export function deepMerge(base, override) {
    if (!isPlainObject(base) || !isPlainObject(override)) {
        return override;
    }
    const result = { ...base };
    for (const key in override) {
        result[key] = deepMerge(base[key], override[key]);
    }
    return result;
}
